import { RootState } from 'store';

export const UserLanguagesLookupState = (state: RootState) => state.lookups.userLanguages;

export const selectUserLanguages = (state: RootState) => UserLanguagesLookupState(state)
    .rows
    .map(({ clientFormOptionName }) => ({ id: clientFormOptionName, name: clientFormOptionName }));
